// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");

function decodeChoice(json) {
  return [
          Json_decode.field("id", Json_decode.string, json),
          Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("label", Json_decode.string, param);
                }), json),
          Json_decode.optional((function (param) {
                  return Json_decode.field("score", Json_decode.$$int, param);
                }), json)
        ];
}

function decode(json) {
  return {
          text: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json),
          description: Json_decode.withDefault("", (function (param) {
                  return Json_decode.field("description", Json_decode.string, param);
                }), json),
          choices: Json_decode.withDefault(/* [] */0, (function (param) {
                  return Json_decode.field("choices", (function (param) {
                                return Json_decode.list(decodeChoice, param);
                              }), param);
                }), json)
        };
}

function makeChoice(text, score, allowNonSpecifiedText, notSpecifiedText) {
  return {
          id: RandomId$ReactHooksTemplate.generate(),
          text: text,
          score: score,
          allowNonSpecifiedText: allowNonSpecifiedText,
          notSpecifiedText: notSpecifiedText
        };
}

function toggleAllowNonSpecifiedText(choice) {
  return {
          id: choice.id,
          text: choice.text,
          score: choice.score,
          allowNonSpecifiedText: !choice.allowNonSpecifiedText,
          notSpecifiedText: choice.notSpecifiedText
        };
}

function getAllowNonSpecifiedText(choice) {
  return choice.allowNonSpecifiedText;
}

function choiceText(choice) {
  return choice.text;
}

function choiceScore(choice) {
  return choice.score;
}

function setNotSpecifiedText(notSpecifiedText, choice) {
  return {
          id: choice.id,
          text: choice.text,
          score: choice.score,
          allowNonSpecifiedText: choice.allowNonSpecifiedText,
          notSpecifiedText: notSpecifiedText
        };
}

function choiceId(choice) {
  return choice.id;
}

function setChoiceText(text, choice) {
  return {
          id: choice.id,
          text: text,
          score: choice.score,
          allowNonSpecifiedText: choice.allowNonSpecifiedText,
          notSpecifiedText: choice.notSpecifiedText
        };
}

function setChoiceScore(score, choice) {
  return {
          id: choice.id,
          text: choice.text,
          score: score,
          allowNonSpecifiedText: choice.allowNonSpecifiedText,
          notSpecifiedText: choice.notSpecifiedText
        };
}

function getChoiceText(choice) {
  return choice.text;
}

function getChoiceScore(choice) {
  return choice.score;
}

function getAnswer(t) {
  return t.answer;
}

function answerIdList(t) {
  var choices = t.answer;
  if (choices !== undefined && choices) {
    return Belt_List.map(choices, (function (x) {
                  return RandomId$ReactHooksTemplate.toString(x.id);
                }));
  } else {
    return /* [] */0;
  }
}

function answerList(t) {
  return Belt_List.map(t.choices, (function (x) {
                return [
                        RandomId$ReactHooksTemplate.toString(x.id),
                        x.text
                      ];
              }));
}

function answered(t) {
  return t.answer !== undefined;
}

function isSelectionValid(t) {
  if (t.multipleAnswer && t.answer !== undefined) {
    var answers = t.answer;
    if (answers === undefined) {
      return false;
    }
    var len = List.length(answers);
    var isMinOk = len >= t.minimumSelections;
    var max = t.maximumSelections;
    var isMaxOk = max !== undefined ? len <= max : true;
    if (isMinOk) {
      return isMaxOk;
    } else {
      return false;
    }
  } else {
    return true;
  }
}

function empty(param) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: "",
          description: "",
          choices: {
            hd: {
              id: RandomId$ReactHooksTemplate.generate(),
              text: "Choice 1",
              score: undefined,
              allowNonSpecifiedText: false,
              notSpecifiedText: undefined
            },
            tl: {
              hd: {
                id: RandomId$ReactHooksTemplate.generate(),
                text: "Choice 2",
                score: undefined,
                allowNonSpecifiedText: false,
                notSpecifiedText: undefined
              },
              tl: /* [] */0
            }
          },
          multipleAnswer: true,
          representation: "TropicalBreezeBackground",
          translations: /* [] */0,
          carryForwardFrom: undefined,
          answer: undefined,
          minimumSelections: 1,
          maximumSelections: undefined
        };
}

function hasChoiceInAnswer(choice, xs) {
  return Belt_List.has(xs, choice, (function (xs, ys) {
                return Caml_obj.equal(xs.id, ys.id);
              }));
}

function carryForwardFrom(t) {
  return t.carryForwardFrom;
}

function clearAnswer(t) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          choices: t.choices,
          multipleAnswer: t.multipleAnswer,
          representation: t.representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: undefined,
          minimumSelections: t.minimumSelections,
          maximumSelections: t.maximumSelections
        };
}

function setAnswer(t, choice) {
  var answer;
  if (t.multipleAnswer) {
    var xs = t.answer;
    if (xs !== undefined) {
      var answer$1 = hasChoiceInAnswer(choice, xs) ? Belt_List.keep(xs, (function (xs) {
                return Caml_obj.notequal(xs.id, choice.id);
              })) : ({
            hd: choice,
            tl: xs
          });
      answer = answer$1 ? answer$1 : undefined;
    } else {
      answer = {
        hd: choice,
        tl: /* [] */0
      };
    }
  } else {
    answer = {
      hd: choice,
      tl: /* [] */0
    };
  }
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          choices: t.choices,
          multipleAnswer: t.multipleAnswer,
          representation: t.representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: answer,
          minimumSelections: t.minimumSelections,
          maximumSelections: t.maximumSelections
        };
}

function setNotSpecifiedTextForAnswer(t, choice) {
  var xs = t.answer;
  var answer = xs !== undefined ? (
      hasChoiceInAnswer(choice, xs) ? Belt_List.map(xs, (function (ys) {
                if (Caml_obj.equal(ys.id, choice.id)) {
                  return choice;
                } else {
                  return ys;
                }
              })) : xs
    ) : undefined;
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          choices: t.choices,
          multipleAnswer: t.multipleAnswer,
          representation: t.representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: answer,
          minimumSelections: t.minimumSelections,
          maximumSelections: t.maximumSelections
        };
}

function text(t) {
  return t.text;
}

function description(t) {
  return t.description;
}

function id(t) {
  return t.id;
}

function uuid(t) {
  return t.uuid;
}

function duplicate(q) {
  return {
          id: undefined,
          uuid: RandomId$ReactHooksTemplate.generate(),
          text: q.text,
          description: q.description,
          choices: q.choices,
          multipleAnswer: q.multipleAnswer,
          representation: q.representation,
          translations: q.translations,
          carryForwardFrom: q.carryForwardFrom,
          answer: q.answer,
          minimumSelections: q.minimumSelections,
          maximumSelections: q.maximumSelections
        };
}

function multipleAnswer(t) {
  return t.multipleAnswer;
}

function representation(t) {
  return t.representation;
}

function choices(t) {
  return t.choices;
}

function minimumSelections(t) {
  return t.minimumSelections;
}

function maximumSelections(t) {
  return t.maximumSelections;
}

function setMinimumSelections(t, minimum) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          choices: t.choices,
          multipleAnswer: t.multipleAnswer,
          representation: t.representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: t.answer,
          minimumSelections: minimum,
          maximumSelections: t.maximumSelections
        };
}

function setMaximumSelections(t, maximum) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          choices: t.choices,
          multipleAnswer: t.multipleAnswer,
          representation: t.representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: t.answer,
          minimumSelections: t.minimumSelections,
          maximumSelections: maximum
        };
}

function setText(t, text) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: text,
          description: t.description,
          choices: t.choices,
          multipleAnswer: t.multipleAnswer,
          representation: t.representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: t.answer,
          minimumSelections: t.minimumSelections,
          maximumSelections: t.maximumSelections
        };
}

function getTextTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].text;
  } else {
    return t.text;
  }
}

function getChoiceTextTranslation(t, choice, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation === undefined) {
    return choice.text;
  }
  var match = List.find_opt((function (param) {
          return param[0] === RandomId$ReactHooksTemplate.toString(choice.id);
        }), translation[1].choices);
  if (match === undefined) {
    return choice.text;
  }
  var text = match[1];
  if (text === "") {
    return choice.text;
  } else {
    return text;
  }
}

function setDescription(t, description) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: description,
          choices: t.choices,
          multipleAnswer: t.multipleAnswer,
          representation: t.representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: t.answer,
          minimumSelections: t.minimumSelections,
          maximumSelections: t.maximumSelections
        };
}

function getDescriptionTranslation(t, language) {
  var translation = List.find_opt((function (param) {
          return param[0] === language;
        }), t.translations);
  if (translation !== undefined) {
    return translation[1].description;
  } else {
    return t.description;
  }
}

function setRepresentation(t, representation) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          choices: t.choices,
          multipleAnswer: t.multipleAnswer,
          representation: representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: t.answer,
          minimumSelections: t.minimumSelections,
          maximumSelections: t.maximumSelections
        };
}

function toggleMultipleAnswer(t) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          choices: t.choices,
          multipleAnswer: !t.multipleAnswer,
          representation: t.representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: t.answer,
          minimumSelections: t.minimumSelections,
          maximumSelections: t.maximumSelections
        };
}

function setChoices(choices, t) {
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          choices: choices,
          multipleAnswer: t.multipleAnswer,
          representation: t.representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: t.answer,
          minimumSelections: t.minimumSelections,
          maximumSelections: t.maximumSelections
        };
}

function removeChoice(choice, choices, t) {
  var newSetOfChoices = Belt_List.keep(choices, (function (xs) {
          return Caml_obj.notequal(xs.id, choice.id);
        }));
  return {
          id: t.id,
          uuid: t.uuid,
          text: t.text,
          description: t.description,
          choices: newSetOfChoices,
          multipleAnswer: t.multipleAnswer,
          representation: t.representation,
          translations: t.translations,
          carryForwardFrom: t.carryForwardFrom,
          answer: t.answer,
          minimumSelections: t.minimumSelections,
          maximumSelections: t.maximumSelections
        };
}

function setChoice(choice, t) {
  var exist = Belt_List.has(t.choices, choice, (function (xs, choice) {
          return Caml_obj.equal(xs.id, choice.id);
        }));
  if (exist) {
    return {
            id: t.id,
            uuid: t.uuid,
            text: t.text,
            description: t.description,
            choices: Belt_List.map(t.choices, (function (xs) {
                    if (Caml_obj.equal(xs.id, choice.id)) {
                      return choice;
                    } else {
                      return xs;
                    }
                  })),
            multipleAnswer: t.multipleAnswer,
            representation: t.representation,
            translations: t.translations,
            carryForwardFrom: t.carryForwardFrom,
            answer: t.answer,
            minimumSelections: t.minimumSelections,
            maximumSelections: t.maximumSelections
          };
  } else {
    return {
            id: t.id,
            uuid: t.uuid,
            text: t.text,
            description: t.description,
            choices: Belt_List.concat(t.choices, {
                  hd: choice,
                  tl: /* [] */0
                }),
            multipleAnswer: t.multipleAnswer,
            representation: t.representation,
            translations: t.translations,
            carryForwardFrom: t.carryForwardFrom,
            answer: t.answer,
            minimumSelections: t.minimumSelections,
            maximumSelections: t.maximumSelections
          };
  }
}

function maximumSelectionReached(t) {
  var match = t.maximumSelections;
  var match$1 = t.answer;
  if (match !== undefined && match$1 !== undefined) {
    return List.length(match$1) === match;
  } else {
    return false;
  }
}

function encodeChoice(choice) {
  var objectEncoderList_0 = [
    "id",
    RandomId$ReactHooksTemplate.toString(choice.id)
  ];
  var objectEncoderList_1 = {
    hd: [
      "label",
      choice.text
    ],
    tl: {
      hd: [
        "score",
        Json_encode.nullable((function (prim) {
                return prim;
              }), choice.score)
      ],
      tl: {
        hd: [
          "allow_non_specified_text",
          choice.allowNonSpecifiedText
        ],
        tl: /* [] */0
      }
    }
  };
  var objectEncoderList = {
    hd: objectEncoderList_0,
    tl: objectEncoderList_1
  };
  var text = choice.notSpecifiedText;
  var textForNonSpecified = text !== undefined ? ({
        hd: [
          "notSpecifiedText",
          text
        ],
        tl: /* [] */0
      }) : /* [] */0;
  return Json_encode.object_(Belt_List.concat(objectEncoderList, textForNonSpecified));
}

function encodeAnswer(answer) {
  return Json_encode.object_({
              hd: [
                "id",
                RandomId$ReactHooksTemplate.toString(answer.id)
              ],
              tl: {
                hd: [
                  "label",
                  answer.text
                ],
                tl: {
                  hd: [
                    "score",
                    Json_encode.nullable((function (prim) {
                            return prim;
                          }), answer.score)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function encodeTextEntries(xs) {
  var textEntries = List.filter(function (x) {
          return Belt_Option.isSome(x.notSpecifiedText);
        })(xs);
  return {
          hd: [
            "text_entries",
            Json_encode.list((function (x) {
                    return Json_encode.object_({
                                hd: [
                                  "id",
                                  RandomId$ReactHooksTemplate.toString(x.id)
                                ],
                                tl: {
                                  hd: [
                                    "text",
                                    Belt_Option.getExn(x.notSpecifiedText)
                                  ],
                                  tl: /* [] */0
                                }
                              });
                  }), textEntries)
          ],
          tl: /* [] */0
        };
}

function nonEmptyChoices(t) {
  return Belt_List.keep(t.choices, (function (choice) {
                return choice.text !== "";
              }));
}

function toJson(withAnswerOpt, t) {
  var withAnswer = withAnswerOpt !== undefined ? withAnswerOpt : false;
  var encodeArray_0 = [
    "id",
    Json_encode.nullable((function (prim) {
            return prim;
          }), t.id)
  ];
  var encodeArray_1 = {
    hd: [
      "text",
      t.text
    ],
    tl: {
      hd: [
        "description",
        t.description
      ],
      tl: {
        hd: [
          "options",
          Json_encode.list(encodeChoice, nonEmptyChoices(t))
        ],
        tl: {
          hd: [
            "multiple_answer",
            t.multipleAnswer
          ],
          tl: {
            hd: [
              "minimum_selections",
              t.minimumSelections
            ],
            tl: {
              hd: [
                "maximum_selections",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.maximumSelections)
              ],
              tl: /* [] */0
            }
          }
        }
      }
    }
  };
  var encodeArray = {
    hd: encodeArray_0,
    tl: encodeArray_1
  };
  var tmp;
  if (withAnswer) {
    var xs = t.answer;
    if (xs !== undefined) {
      var encodedTextEntries = encodeTextEntries(xs);
      tmp = Belt_List.concatMany([
            {
              hd: [
                "answer",
                Json_encode.list(encodeAnswer, xs)
              ],
              tl: /* [] */0
            },
            encodeArray,
            encodedTextEntries
          ]);
    } else {
      tmp = /* [] */0;
    }
  } else {
    tmp = encodeArray;
  }
  return Json_encode.object_(tmp);
}

function decodeChoice$1(json) {
  return {
          id: Json_decode.field("id", RandomId$ReactHooksTemplate.fromJson, json),
          text: Json_decode.field("label", Json_decode.string, json),
          score: Json_decode.optional((function (param) {
                  return Json_decode.field("score", Json_decode.$$int, param);
                }), json),
          allowNonSpecifiedText: Json_decode.withDefault(false, (function (param) {
                  return Json_decode.field("allow_non_specified_text", Json_decode.bool, param);
                }), json),
          notSpecifiedText: undefined
        };
}

function decodeTranslation(json) {
  return [
          Json_decode.field("survey_language", (function (param) {
                  return Json_decode.field("name", Json_decode.string, param);
                }), json),
          Json_decode.field("key_string_mapping", decode, json)
        ];
}

function fromJson(json) {
  return {
          id: Json_decode.field("category", (function (param) {
                  return Json_decode.field("id", (function (param) {
                                return Json_decode.optional(Json_decode.$$int, param);
                              }), param);
                }), json),
          uuid: Json_decode.field("uid", RandomId$ReactHooksTemplate.fromJson, json),
          text: Json_decode.field("category", (function (param) {
                  return Json_decode.field("text", Json_decode.string, param);
                }), json),
          description: Json_decode.field("category", (function (param) {
                  return Json_decode.field("description", Json_decode.string, param);
                }), json),
          choices: Json_decode.field("category", (function (param) {
                  return Json_decode.field("options", (function (param) {
                                return Json_decode.list(decodeChoice$1, param);
                              }), param);
                }), json),
          multipleAnswer: Json_decode.field("category", (function (param) {
                  return Json_decode.field("multiple_answer", Json_decode.bool, param);
                }), json),
          representation: "TropicalBreezeBackground",
          translations: Json_decode.field("translations", (function (param) {
                  return Json_decode.list(decodeTranslation, param);
                }), json),
          carryForwardFrom: Json_decode.field("category", (function (param) {
                  return Json_decode.optional((function (param) {
                                return Json_decode.field("options_from_uid", RandomId$ReactHooksTemplate.fromJson, param);
                              }), param);
                }), json),
          answer: undefined,
          minimumSelections: Json_decode.field("category", (function (param) {
                  return Json_decode.field("minimum_selections", Json_decode.$$int, param);
                }), json),
          maximumSelections: Json_decode.field("category", (function (param) {
                  return Json_decode.field("maximum_selections", (function (param) {
                                return Json_decode.optional(Json_decode.$$int, param);
                              }), param);
                }), json)
        };
}

var categoryType = "MultipleSelect";

exports.text = text;
exports.getTextTranslation = getTextTranslation;
exports.description = description;
exports.getDescriptionTranslation = getDescriptionTranslation;
exports.choices = choices;
exports.minimumSelections = minimumSelections;
exports.maximumSelections = maximumSelections;
exports.multipleAnswer = multipleAnswer;
exports.representation = representation;
exports.choiceText = choiceText;
exports.choiceScore = choiceScore;
exports.choiceId = choiceId;
exports.setMinimumSelections = setMinimumSelections;
exports.setMaximumSelections = setMaximumSelections;
exports.setText = setText;
exports.setDescription = setDescription;
exports.setRepresentation = setRepresentation;
exports.setChoiceText = setChoiceText;
exports.setChoiceScore = setChoiceScore;
exports.getChoiceText = getChoiceText;
exports.getChoiceScore = getChoiceScore;
exports.getChoiceTextTranslation = getChoiceTextTranslation;
exports.setChoices = setChoices;
exports.setChoice = setChoice;
exports.removeChoice = removeChoice;
exports.toggleMultipleAnswer = toggleMultipleAnswer;
exports.uuid = uuid;
exports.id = id;
exports.clearAnswer = clearAnswer;
exports.setAnswer = setAnswer;
exports.answered = answered;
exports.maximumSelectionReached = maximumSelectionReached;
exports.toJson = toJson;
exports.categoryType = categoryType;
exports.empty = empty;
exports.carryForwardFrom = carryForwardFrom;
exports.makeChoice = makeChoice;
exports.getAnswer = getAnswer;
exports.answerIdList = answerIdList;
exports.isSelectionValid = isSelectionValid;
exports.answerList = answerList;
exports.toggleAllowNonSpecifiedText = toggleAllowNonSpecifiedText;
exports.getAllowNonSpecifiedText = getAllowNonSpecifiedText;
exports.fromJson = fromJson;
exports.setNotSpecifiedText = setNotSpecifiedText;
exports.setNotSpecifiedTextForAnswer = setNotSpecifiedTextForAnswer;
exports.nonEmptyChoices = nonEmptyChoices;
exports.duplicate = duplicate;
/* RandomId-ReactHooksTemplate Not a pure module */
